import styled from "styled-components";
import { Input } from "@mui/material";

export const StyledInputResizer = styled(Input)`
  && {
    border: 1px solid #eaecf0;
    outline: none;
    background-color: #ffffff;
    font-family: DM Sans;
    font-size: 12px;
    font-weight: 400;
    color: #565556;
    width: 174px;
    height: 40px;
    border-radius: 8px;
    padding-left: 10px;
    text-align: center;
    &:focus {
      border: none;
      outline: none;
    }

    &::before,
    &::after {
      display: none; // Removes underline on focus and in general
    }
  }
`;
